import React from "react";
import PropTypes from "prop-types";
import Typography from "@limitless/modern/data-display/typography/Typography";
import Link from "@mui/material/Link";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(theme => ({
    layout: {
        marginTop: "12px",
        display: "inline",
        gap: "12px",
        marginRight: "4px"
    },
    h6: {
        fontFamily: "Roboto",
        fontSize: "20px",
        fontWeight: 500,
        lineHeight: "28px",
        marginBottom: "12px"
    },
    body: {
        marginTop: "12px",
        display: "inline"
    },
    hyperlinkSection: {
        display: "inline",
        cursor: "pointer",
        color: theme.palette.primary.main,
        textDecoration: "none",
        lineHeight: "18px"
    },
    display: {
        display: "inline"
    },
    caption: {
        display: "block",
        marginTop: "12px"
    },
    body2: {
        marginTop: "12px",
        display: "inline",
        marginLeft: "2px"
    }
}));

const ReceiveMessageScreen = ({ handleConversationHistory }) => {
    const classes = useStyles();

    return (
        <>
            <div>
                <Typography variant="h6" weight="500" className={classes.h6}>
                    {"We’ve received your message"}
                </Typography>
                <Typography variant="body2" weight="400" component="div" className={classes.layout}>
                    {"Thank you for your message. We're aiming to respond as quickly as possible. Keep an eye on the"}
                </Typography>
                <Typography
                    variant="caption"
                    weight="400"
                    className={classes.hyperlinkSection}
                    component={Link}
                    onClick={handleConversationHistory}
                >
                    {"Conversation history"}
                </Typography>
                <Typography variant="body2" weight="400" component="div" className={classes.body2}>
                    {" for our response"}
                </Typography>
            </div>
        </>
    );
};

export default ReceiveMessageScreen;

ReceiveMessageScreen.propTypes = {
    handleConversationHistory: PropTypes.func
};
